<template>
  <div class="account-limit-error">
    <div class="row">
      <div class="col-lg-6 col-lg-offset-3">
        <div class="box">
          <div class="box-body">
            <center><i class="fa fa-exclamation-triangle fa-bigger green"></i>
              <br/><br/>
            <p>Sorry, this account has reached the maximum number of drivers
              allowed to register. Please contact the account owner as the
              account will need to be upgraded in order to allow more drivers.
            </p>
            <p>You can alternatively register for your own account by clicking
              <a class="email" v-link="{ path: '/sign-up' }">here</a> and choosing
              a membership option.
            </p>
            <hr/>
            <p>If you have any questions, just give us a call at
              <a href="tel:1300575878">1300 575 878</a> or you can email
              <a href="mailto:info@greensharecar.com.au" class="email">
                info@greensharecar.com.au</a>. We're always happy to help!</p>
            <p><img v-bind:src="'https://techcar-dev.s3.amazonaws.com/'+ ( $root.companyLogo ? $root.companyLogo : 'spacer.gif' ) + '?v=' + new Date().getTime()" v-bind:alt="companyName" /><br/> </p></center>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountLimitError',
  components: {
  },
  data () {
    return {
    }
  },
  ready () {
  },
  route: {
    data () {
    }
  },
  methods: {
  }
}
  </script>



// WEBPACK FOOTER //
// AccountLimitError.vue?768ca111